import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { G, Mask, Path, Rect } from "react-native-svg";

const SvgUa = (props: SvgProps) => (
  <Svg width={22} height={16} fill="none" {...props}>
    <Rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#157CBB"
      stroke="#157CBB"
      strokeWidth={0.5}
      rx={1.75}
    />
    <Mask
      id="ua-flag"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <Rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </Mask>
    <G mask="url(#ua-flag)">
      <Path fill="#FFD34D" fillRule="evenodd" d="M0 16h22V7.467H0z" clipRule="evenodd" />
    </G>
  </Svg>
);
const Memo = memo(SvgUa);
export default Memo;
